export default __webpack_public_path__ + "1edd1a4dd9b2a441b39012ae04d93149.otf";